// @ts-nocheck
import React, { useState } from "react"

import { formatPhone } from "../../util/formating"
import styles from "./styles"

import { FormControl, OutlinedInput } from "@mui/material"
import { InputLabel, InputAdornment, FormHelperText } from "@mui/material"

export default function InputPhone(props) {
	const { label, value, setValue, onChange, onBlur, sx,errorText } = props
	const [helperText, setHelperText] = useState(() => "")

	let startAdornment = null
	if (Boolean(value)) startAdornment = <InputAdornment position="start">+1</InputAdornment>

	function handleChange(event) {
		let value = event?.target?.value
		value = value?.replace(/\D/g, "")

		const backspace = event?.nativeEvent?.inputType === "deleteContentBackward"
		if (backspace && value?.length <= 6) value = value?.slice(0, -1)

		const phoneRegex = /^\d{0,10}$/
		if (!phoneRegex.test(value)) return

		value = formatPhone({ phone: value })
		setValue(value)

		if (onChange) onChange({ value })
	}

	function handleBlur(event) {
		let value = event.target.value
		value = value?.replace(/\D/g, "")

		const error = validatePhone(value)
		if (onBlur) onBlur({ value, error })
	}

	function validatePhone(value) {
		const phoneRegex = /^\d{10}$/

		let error = ""
		if (value && !phoneRegex.test(value)) error = "Please enter a valid phone number"

		setHelperText(error)
		return error
	}

	return (
		<FormControl variant="outlined" sx={{ ...styles.container, ...sx }}>
			<InputLabel htmlFor={`input-phone-${label}`} sx={{ ...styles?.label, ...sx?.label }}>
				{label}
			</InputLabel>

			<OutlinedInput
				id={`input-phone-${label}`}
				label={label}
				type="text"
				value={value}
				onChange={handleChange}
				inputProps={{ onBlur: handleBlur }}
				startAdornment={startAdornment}
				sx={{ ...styles?.input(value,errorText), ...sx?.input }}
			/>

      		{/* {Boolean(errorText) && <FormHelperText sx={styles.errorText}>{errorText}</FormHelperText>} */}
			{(Boolean(helperText) || Boolean(errorText)) && <FormHelperText sx={styles.helperText}>{helperText || errorText}</FormHelperText>}
		</FormControl>
	)
}
